"use strict";
/** state: Final **/
/** family: TreeView **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var keycode = require("keycode");
var React = require("react");
var ReactDOM = require("react-dom");
var trackMetric_1 = require("../../metrics/trackMetric");
var icon_types_1 = require("../../types/icon.types");
var Badge_1 = require("../Badge");
var Checkbox_1 = require("../Checkbox");
var FontAwesome_1 = require("../FontAwesome");
var IconWrapper_1 = require("../IconWrapper");
var TreeView_1 = require("../TreeView");
var utils_1 = require("../TreeView/utils");
var utils_2 = require("../utils");
var CLASS_NAME = 'i-tree-view__item';
/**
 * TreeViewItem is passed to TreeView
 *
 * Some text for TreeViewItem
 *
 * @param {TreeViewItemProps} props
 * @returns {any}
 * @constructor
 */
var TreeViewItem = /** @class */ (function (_super) {
    __extends(TreeViewItem, _super);
    function TreeViewItem(props) {
        var _this = _super.call(this, props) || this;
        // Returns a FontAwesome IconName for the dropdown
        _this.getDropdownName = function () {
            switch (_this.props.dropdownType) {
                case TreeView_1.TreeViewDropdownType.Caret:
                    return _this.state.expanded ? icon_types_1.Icon.AngleUp : icon_types_1.Icon.AngleDown;
                case TreeView_1.TreeViewDropdownType.Explorer:
                case TreeView_1.TreeViewDropdownType.ExplorerLines:
                    return (_this.state.expanded ? icon_types_1.Icon.MinusSquare : icon_types_1.Icon.PlusSquare) + " fa-lg";
            }
        };
        _this.handleBlur = function () {
            ReactDOM.findDOMNode(_this).setAttribute('tabIndex', '-1');
        };
        _this.handleClick = function (e) {
            _this.toggleDisplay();
            _this.props.onClick && _this.props.onClick(e);
        };
        _this.handleKeyDown = function (e) {
            var supportedNonVisibleKeys = [
                keycode('Enter'),
                keycode('Space'),
                keycode('Home'),
                keycode('End'),
                keycode('Up'),
                keycode('Down'),
                keycode('Left'),
                keycode('Right'),
            ];
            if (supportedNonVisibleKeys.indexOf(e.keyCode) > -1) {
                e.preventDefault && e.preventDefault();
                e.stopPropagation && e.stopPropagation();
                switch (e.keyCode) {
                    case keycode('Enter'):
                        if (!_this.props.disabled) {
                            if (_this.props.onClick) {
                                trackMetric_1.trackMetric(_this.props.metricOptions)();
                                _this.props.onClick(e);
                            }
                            else if (_this.props.children) {
                                _this.toggleDisplay();
                            }
                            if (_this.props.href) {
                                trackMetric_1.trackMetric(_this.props.metricOptions)();
                                window.location.assign(_this.props.href);
                            }
                        }
                        break;
                    case keycode('Space'):
                        if (!_this.props.disabled) {
                            if (_this.props.checkboxProps &&
                                _this.props.checkboxProps.onChange) {
                                _this.props.checkboxProps.onChange(e, _this.props.checkboxProps);
                            }
                            else if (_this.props.children) {
                                _this.toggleDisplay();
                            }
                        }
                        break;
                    case keycode('Home'):
                        utils_1.NavigateTree.focus(utils_1.NavigateTree.getNode(utils_1.NavigateTree.getRoot(ReactDOM.findDOMNode(_this)), utils_1.NavigateTree.getFirstChild, utils_1.NavigateTree.getNextSibling));
                        break;
                    case keycode('End'):
                        utils_1.NavigateTree.focus(utils_1.NavigateTree.getNode(utils_1.NavigateTree.getRoot(ReactDOM.findDOMNode(_this)), utils_1.NavigateTree.getLastChild, utils_1.NavigateTree.getPreviousSibling));
                        break;
                    case keycode('Up'):
                        utils_1.NavigateTree.focus(utils_1.NavigateTree.getNode(ReactDOM.findDOMNode(_this), utils_1.NavigateTree.getPreviousSiblingLastChild, utils_1.NavigateTree.getPreviousSibling, utils_1.NavigateTree.getParent));
                        break;
                    case keycode('Down'):
                        utils_1.NavigateTree.focus(utils_1.NavigateTree.getNode(ReactDOM.findDOMNode(_this), utils_1.NavigateTree.getFirstChild, utils_1.NavigateTree.getNextSibling, utils_1.NavigateTree.getParentNextSibling));
                        break;
                    case keycode('Left'):
                        if (_this.props.children && _this.state.expanded) {
                            _this.toggleDisplay();
                        }
                        else {
                            utils_1.NavigateTree.focus(utils_1.NavigateTree.getNode(ReactDOM.findDOMNode(_this), utils_1.NavigateTree.getParent));
                        }
                        break;
                    case keycode('Right'):
                        if (!_this.props.children) {
                            break;
                        }
                        if (!_this.state.expanded) {
                            _this.toggleDisplay();
                        }
                        else {
                            utils_1.NavigateTree.focus(utils_1.NavigateTree.getNode(ReactDOM.findDOMNode(_this), utils_1.NavigateTree.getFirstChild, utils_1.NavigateTree.getNextSibling));
                        }
                        break;
                }
            }
            else if (utils_2.KeyDown.isVisibleCharacter(e)) {
                e.preventDefault && e.preventDefault();
                e.stopPropagation && e.stopPropagation();
                utils_1.NavigateTree.focus(utils_1.NavigateTree.getNextMatch(ReactDOM.findDOMNode(_this), keycode(e.keyCode)) ||
                    utils_1.NavigateTree.getNextMatch(utils_1.NavigateTree.getRoot(ReactDOM.findDOMNode(_this)), keycode(e.keyCode)));
            }
        };
        _this.injectPropsOnChildren = function () {
            return React.Children.map(_this.props.children, function (child) {
                if (utils_2.isType(child, TreeViewItem)) {
                    return React.cloneElement(child, {
                        dropdownType: _this.props
                            .dropdownType,
                        filterMatch: utils_2.FindText.hasMatch(_this.props.label, _this.props.filterText) ||
                            _this.props.filterMatch,
                        filterText: _this.props.filterText,
                    });
                }
                return child;
            });
        };
        // If `filterText` is provided, return null if it doesn't match with
        // (1) any of the item's ancestors (passed via filterMatch);
        // (2) the item's label; or
        // (3) any of item's children
        _this.shouldRenderItem = function () {
            return (_this.props.filterText &&
                !(_this.props.filterMatch ||
                    utils_2.FindText.hasMatch(_this.props.label, _this.props.filterText) ||
                    _this.childrenHasMatch(_this.props.children, _this.props.filterText)));
        };
        _this.calcExpanded = function (expanded, filterText) {
            return expanded === undefined ? !!filterText : expanded;
        };
        _this.state = {
            expanded: _this.calcExpanded(props.expanded, props.filterText),
        };
        return _this;
    }
    TreeViewItem.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.expanded !== this.props.expanded ||
            nextProps.filterText !== this.props.filterText) {
            this.setState({
                expanded: this.calcExpanded(nextProps.expanded, nextProps.filterText),
            });
        }
    };
    TreeViewItem.prototype.componentDidUpdate = function (_, prevState) {
        if (prevState.expanded !== this.state.expanded) {
            if (this.state.expanded) {
                this.props.onExpand && this.props.onExpand(this);
            }
            else {
                this.props.onCollapse && this.props.onCollapse(this);
            }
        }
    };
    TreeViewItem.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, active = _b.active, badgeProps = _b.badgeProps, checkboxProps = _b.checkboxProps, children = _b.children, className = _b.className, disabled = _b.disabled, divider = _b.divider, dropdownType = _b.dropdownType, expanded = _b.expanded, filterText = _b.filterText, filterMatch = _b.filterMatch, href = _b.href, label = _b.label, metricOptions = _b.metricOptions, onClick = _b.onClick, onCollapse = _b.onCollapse, onExpand = _b.onExpand, restProps = __rest(_b, ["active", "badgeProps", "checkboxProps", "children", "className", "disabled", "divider", "dropdownType", "expanded", "filterText", "filterMatch", "href", "label", "metricOptions", "onClick", "onCollapse", "onExpand"]);
        if (this.shouldRenderItem()) {
            return null;
        }
        if (divider) {
            return (React.createElement("div", __assign({ className: classNames(CLASS_NAME, className, CLASS_NAME + "--divider"), role: "separator" }, restProps)));
        }
        var injectedChildren = this.injectPropsOnChildren();
        var classes = classNames(CLASS_NAME, className, (_a = {},
            _a[CLASS_NAME + "--active"] = active,
            _a[CLASS_NAME + "--disabled"] = disabled,
            _a));
        // FontAwesome Icon for the dropdown element
        var dropdownIcon = injectedChildren && dropdownType && (React.createElement(IconWrapper_1.IconWrapper, null,
            React.createElement(FontAwesome_1.FontAwesome, { className: CLASS_NAME + "__dropdown-" + dropdownType, name: this.getDropdownName() })));
        var content = (React.createElement(React.Fragment, null,
            (dropdownType === TreeView_1.TreeViewDropdownType.Explorer ||
                dropdownType === TreeView_1.TreeViewDropdownType.ExplorerLines) &&
                dropdownIcon,
            React.createElement("div", null,
                checkboxProps ? (React.createElement(Checkbox_1.Checkbox, __assign({}, checkboxProps, { disabled: disabled, label: label, onClick: function (e) {
                        e.stopPropagation();
                        utils_1.NavigateTree.focus(utils_1.NavigateTree.getNode(ReactDOM.findDOMNode(_this), utils_1.NavigateTree.focus));
                        return false;
                    } }))) : (React.createElement("span", { className: CLASS_NAME + "__label" }, utils_2.FindText.highlightMatch(label, filterText))),
                badgeProps && React.createElement(Badge_1.Badge, __assign({}, badgeProps)),
                dropdownType === TreeView_1.TreeViewDropdownType.Caret &&
                    dropdownIcon)));
        return (React.createElement("li", __assign({ className: classes, role: "treeitem", onBlur: this.handleBlur, onKeyDown: this.handleKeyDown, tabIndex: -1, "aria-expanded": injectedChildren ? !!this.state.expanded : null, "aria-disabled": disabled, "aria-selected": checkboxProps ? checkboxProps.checked === true : null }, restProps),
            href ? (React.createElement("a", { href: href, onClick: !disabled &&
                    trackMetric_1.trackMetric(metricOptions, this.handleClick) }, content)) : (React.createElement("div", { onClick: !disabled &&
                    trackMetric_1.trackMetric(metricOptions, this.handleClick) }, content)),
            injectedChildren && this.state.expanded && (React.createElement("ul", { role: "group" }, injectedChildren))));
    };
    // Check if any nested title or item contains a match for the filter text
    TreeViewItem.prototype.childrenHasMatch = function (childrenNode, filterText) {
        var _this = this;
        return React.Children.toArray(childrenNode).some(function (child) {
            return utils_2.FindText.hasMatch(child.props.label, filterText) ||
                (child.props.children &&
                    _this.childrenHasMatch(child.props.children, filterText));
        });
    };
    TreeViewItem.prototype.toggleDisplay = function () {
        if (!this.props.disabled) {
            this.setState({ expanded: !this.state.expanded });
        }
    };
    return TreeViewItem;
}(React.Component));
exports.TreeViewItem = TreeViewItem;
//# sourceMappingURL=TreeViewItem.js.map